/** Espelha origem_ocorrencia (db_repo_dfse) e OrigemOcorrenciaEnum (API RepoDFSe): quem produziu a ocorrência. */
export enum OrigemOcorrenciaEnum {
  Usuario = 1,
  Sistema = 2,
  Automacao = 3,
  RotinaAgendada = 4,
  ServicoExterno = 5,
}
